<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card"
      />
      <Form @submit="handlePassword" :validation-schema="schema">
        <div v-if="!successful">
          <div class="form-group">
            <label >Usuário</label>
            <label>{{  currentUser.username }}</label>
            
            <ErrorMessage name="username" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="passwordAtual">Senha atual</label>
            <Field name="passwordAtual" type="password" class="form-control" />
            <ErrorMessage name="passwordAtual" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="passwordNovo">Nova senha</label>
            <Field name="passwordNovo" type="password" class="form-control" />
            <ErrorMessage name="passwordNovo" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="passwordNovo1">Confirmar nova senha</label>
            <Field name="passwordNovo1" type="password" class="form-control" />
            <ErrorMessage name="passwordNovo1" class="error-feedback" />
          </div>

          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              Trocar Senha
            </button>
          </div>
        </div>
      </Form>

      <div
        v-if="message"
        class="alert"
        :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import userService from "../services/user.service";

export default {
  name: "ChangePassword",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    var schema = yup.object();
    schema = yup.object().shape({
      username: yup
        .string()
        .required("Username is required!")
        .min(3, "Must be at least 3 characters!")
        .max(20, "Must be maximum 20 characters!"),
      passwordAtual: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
      passwordNovo: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
      passwordNovo1: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
    });
    return {
      successful: false,
      loading: false,
      message: "",
      schema,
      userID: "",
    };
  },
  computed: {
    loggedIn() {
      return (this.$store.state.auth.status.loggedIn && this.$store.state.auth.user.validOTP);
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      this.$root.logOut();
    }
  },
  methods: {
    handlePassword(data) {
      this.message = "";
      this.successful = false;
      this.loading = true;

      userService.changepwd(data).then(
        (response) => {
          this.message = response.data.message;
          this.successful = true;
          this.loading = true;
          setTimeout(() => {
            this.message = "";
            this.successful = false;
            this.loading = false;
            this.$router.push("/profile");
          }, 3000);
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
